<template>
  <div class="funnel-chart-container">
    <div class="arrows">
      <div v-for="(bar, index) in barsData" :key="bar.description">
        <div v-if="index === 0" class="arrow-line" style="height: 88px; margin-top: 10px">
          <div class="arrow"></div>
        </div>
        <div v-else-if="index < barsData.length - 1" class="arrow-line">
          <div class="arrow"></div>
        </div>
      </div>
    </div>
    <div class="bars">
      <progress-funnel-bar
        v-for="bar in barsData"
        :key="bar.description"
        hide-dot
        :color="bar.color"
        :value="bar.value"
        :percentage="bar.percentage"
        :bar-width="bar.width"
        :description="bar.description"
      />
    </div>
  </div>
</template>

<script>
import ProgressFunnelBar from '../../modules/industria/ofertas-trade/views/components/coupons-funnel/ProgressFunnelBar.vue'
export default {
  name: 'FunnelChart',
  components: {
    ProgressFunnelBar,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    offerType: {
      type: String,
      validator: (value) =>
        [
          'general',
          'percentage',
          'dynamic_pricing_percentage',
          'takepay',
          'combo',
          'cashback_percentage',
          'cashback_absolute',
          'points',
          'nextbuycashback',
          'dynamic_rule',
          'crosssell',
        ].includes(value),
    },
    metrics: {
      type: Object,
      default: () => {},
    },
    tab: {
      type: [String, Number],
      default: null,
    },
    activatable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    barsData() {
      let bars = []
      if (this.offerType === 'combo') {
        const couponsWithProductsTotal = {
          color: '#002040',
          value: this.comboCouponsWithProducts,
          description: `Total de cupons com produtos  ${this.tab ? 'alvo' : 'gatilho'} (Clube e não clube)`,
          percentage: 100,
          width: 100,
        }
        const couponsClubWithProducts = {
          color: '#0063C6',
          value: this.comboCouponsClubWithProducts,
          description: `Cupons do clube com produtos ${this.tab ? 'alvo' : 'gatilho'}`,
          percentage: this.comboCouponsClubWithProductsPercentage,
          width: this.comboCouponsClubWithProductsPercentage,
        }
        const couponsClubWithDiscount = {
          color: '#00B395',
          value: this.comboCouponsClubWithDiscount,
          description: 'Cupons com quantidade elegível (produto gatilho + produto alvo)',
          percentage: this.comboCouponsClubWithDiscountPercentage,
          width: this.comboCouponsClubWithDiscountWidth,
        }
        bars.push(couponsWithProductsTotal, couponsClubWithProducts, couponsClubWithDiscount)
      } else {
        const couponsWithProductsTotal = {
          color: '#002040',
          value: this.couponsWithProducts,
          description: 'Total de cupons com produtos (Clube e não clube)',
          percentage: 100,
          width: 100,
        }
        const couponsClubWithProducts = {
          color: '#0063C6',
          value: this.couponsClubWithProducts,
          description: 'Cupons do clube com produtos',
          percentage: this.couponsClubWithProductsPercentage,
          width: this.couponsClubWithProductsPercentage,
        }
        const couponsEligibleTotal = {
          color: '#00B395',
          value: this.couponsEligible,
          description: 'Cupons com quantidade elegível',
          percentage: this.couponsEligiblePercentage,
          width: this.couponsEligibleWidth,
        }
        bars.push(couponsWithProductsTotal, couponsClubWithProducts, couponsEligibleTotal)
      }
      if (this.activatable) {
        let activatedPercentage = 0
        let activatedWidth = 0
        if (this.offerType === 'combo') {
          activatedPercentage = this.comboCouponsClubWithDiscount > 0 ? (this.couponsActivated * 100) / this.comboCouponsClubWithDiscount : 0
          activatedWidth = (this.comboCouponsClubWithDiscountWidth * activatedPercentage) / 100
        } else {
          activatedPercentage = this.couponsActivatedPercentage
          activatedWidth = (this.couponsEligibleWidth * activatedPercentage) / 100
        }
        const activatedBar = {
          color: '#94B300',
          value: this.couponsActivated,
          description: 'Cupons que ativaram e consumiram a oferta',
          percentage: activatedPercentage,
          width: activatedWidth,
        }
        bars.push(activatedBar)
      }
      return bars
    },
    couponsWithProducts() {
      return this.metrics?.products_metrics?.totals?.total?.tickets || 0
    },
    couponsClubWithProducts() {
      return this.metrics?.products_metrics?.totals?.total?.loyalty_tickets || 0
    },
    couponsActivated() {
      return this.metrics?.clients_metrics?.with_sales?.tickets || 0
    },
    couponsEligible() {
      return this.metrics?.eligible_metrics?.loyalty_tickets || 0
    },
    comboCouponsWithProducts() {
      if (this.tab) {
        return this.metrics?.products_metrics.totals?.total?.tickets || 0
      } else {
        return this.metrics?.products_trigger_metrics?.totals?.total?.tickets || 0
      }
    },
    comboCouponsClubWithProducts() {
      if (this.tab) {
        return this.metrics?.products_metrics?.totals?.total?.loyalty_tickets || 0
      } else {
        return this.metrics?.products_trigger_metrics?.totals?.total?.loyalty_tickets || 0
      }
    },
    comboCouponsClubWithDiscount() {
      return this.metrics?.eligible_metrics?.loyalty_tickets || 0
    },
    couponsClubWithProductsPercentage() {
      return this.couponsWithProducts > 0 ? (this.couponsClubWithProducts * 100) / this.couponsWithProducts : 0
    },
    couponsEligiblePercentage() {
      return this.couponsClubWithProducts > 0 ? (this.couponsEligible * 100) / this.couponsClubWithProducts : 0
    },
    couponsEligibleWidth() {
      return (this.couponsClubWithProductsPercentage * this.couponsEligiblePercentage) / 100
    },
    couponsActivatedPercentage() {
      return this.couponsEligible > 0 ? (this.couponsActivated * 100) / this.couponsEligible : 0
    },
    comboCouponsClubWithProductsPercentage() {
      return this.comboCouponsWithProducts > 0 ? (this.comboCouponsClubWithProducts * 100) / this.comboCouponsWithProducts : 0
    },
    comboCouponsClubWithDiscountPercentage() {
      return this.comboCouponsClubWithProducts > 0 ? (this.comboCouponsClubWithDiscount * 100) / this.comboCouponsClubWithProducts : 0
    },
    comboCouponsClubWithDiscountWidth() {
      return (this.comboCouponsClubWithDiscountPercentage * this.comboCouponsClubWithProductsPercentage) / 100
    },
  },
}
</script>

<style lang="scss" scoped>
.funnel-chart-container {
  display: flex;
  flex-direction: row;
  gap: 4px;

  .arrows {
    width: 1%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .arrow-line {
      position: relative;
      margin-top: -10px;
      width: 100%;
      height: 82px;
      border: 1px solid #969ea7;
      border-right: none;
      border-radius: 6px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .arrow {
      position: absolute;
      width: 5px;
      height: 5px;
      border-left: 1px solid #969ea7;
      border-bottom: 1px solid #969ea7;
      bottom: -3px;
      right: 0;
      transform: rotate(226deg);
    }
  }

  .bars {
    width: 99%;
    display: flex;
    flex-direction: column;
    gap: 22px;
  }
}
</style>
